import { gql } from '@apollo/client/core'
import { useMutation } from '@vue/apollo-composable'
import { IUpdateUserFavoritesResponse } from '@types'

const ADD_TO_USER_FAVORITES_MUTATION = gql`
  mutation Mutation($updateUserFavoritesInput: UpdateUserFavoritesInput!) {
    addToUserFavorites(UpdateUserFavoritesInput: $updateUserFavoritesInput) {
      type
      payload {
        ... on StringResponse {
          message
        }
      }
    }
  }
`

export const useAddToUserFavoritesMutation = () => {
  const mutation = useMutation<IUpdateUserFavoritesResponse>(ADD_TO_USER_FAVORITES_MUTATION)
  return mutation
}
